import { Module } from '../api/module';

function useLicenses() {
  function hasOnlyDemoProductLicenseForTeacher(module: Module | undefined) {
    return (
      module?.licenses.hasDemoProductLicenseForTeacher &&
      !(module.licenses.hasDocumentLicenseForTeacher || module.licenses.hasDocumentLicenseForStudent)
    );
  }

  return {
    hasOnlyDemoProductLicenseForTeacher,
  };
}

export default useLicenses;
